import * as z from 'zod';

// Enums
export const ipAllocationImportStatusEnum = z.enum([
  'queued',
  'running',
  'paused',
  'cancelled',
  'completed',
  'failed',
]);
export type IpAllocationImportStatus = z.infer<typeof ipAllocationImportStatusEnum>;

// 1. Reference schema with label field (for dropdowns, selects, links)
export const readIpAllocationImportRefSchema = z.object({
  id: z.uuid(),
  sourceName: z.string().nullable(),
  status: ipAllocationImportStatusEnum,
});
export type ReadIpAllocationImportRef = z.infer<typeof readIpAllocationImportRefSchema>;

// 2. Minimal reference schema (for foreign keys)
export const ipAllocationImportRefSchema = z.object({
  id: z.uuid(),
});
export type IpAllocationImportRef = z.infer<typeof ipAllocationImportRefSchema>;

// 3. Read schema - all properties nullable (API response)
export const readIpAllocationImportSchema = z.object({
  id: z.uuid().nullable(),
  sourceUrl: z.string().nullable(),
  sourceName: z.string().nullable(),
  sourceChecksum: z.string().nullable(),
  status: ipAllocationImportStatusEnum.nullable(),
  totalChunks: z.number().nullable(),
  completedChunks: z.number().nullable(),
  failedChunks: z.number().nullable(),
  totalRows: z.number().nullable(),
  importedRows: z.number().nullable(),
  failedRows: z.number().nullable(),
  retryCount: z.number().nullable(),
  lastError: z.string().nullable(),
  startedAt: z.iso.datetime().nullable(),
  pausedAt: z.iso.datetime().nullable(),
  finishedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime().nullable(),
  updatedAt: z.iso.datetime().nullable(),
});
export type ReadIpAllocationImport = z.infer<typeof readIpAllocationImportSchema>;

// 4. Create schema
export const createIpAllocationImportSchema = z.object({
  sourceUrl: z
    .string()
    .min(1, 'Source URL is required')
    .url('Source URL must be a valid URL'),
  sourceName: z.string().optional(),
  sourceChecksum: z.string().optional()
});
export type CreateIpAllocationImport = z.infer<typeof createIpAllocationImportSchema>;

// Legacy export for backward compatibility
export const ipAllocationImportSchema = readIpAllocationImportSchema;
export type IpAllocationImport = ReadIpAllocationImport;
